document.addEventListener('AppleIDSignInOnSuccess', (data) => {
    let detail = data.detail;
    detail.origin = 'login';

    jQuery.ajax({
        url: "/wp-content/themes/wp-bootstrap-starter-child/lib/AppleSignin.php",
        type: "POST",
        beforeSend: function(xhr){xhr.setRequestHeader('csrf_token', jQuery('meta[name="csrf-token"]').attr('content'));},
        data: detail,
        dataType: "json",
        async: true,
        success: function(returnVal) {
            console.log(returnVal);
            let redirectLink = jQuery("[name='redirect']").val() === '' ? returnVal.data.sendTo : '/' + jQuery("[name='redirect']").val();
            window.location.href = redirectLink;
        },
        error: function(error) {
            console.error(error.responseJSON.data);
            if(error.responseJSON.data == 'No subscription.')
            {
                window.location.href = "https://snackcrate.com/onboarding-step-1/?info=noaccount";
            }
            else
            {
                console.error('Error: ', error);
                jQuery(".form-error").show().text(error.responseJSON.data);
            }
        }
    });
});
//Listen for authorization failures
document.addEventListener('AppleIDSignInOnFailure', (error) => {
    console.error(error);
});

jQuery(document).ready(function() {
    if(jQuery('body').hasClass('login')) {
        // allow user to toggle password visibility
        const loginPassword = document.querySelector('#password');
        const toggleLoginPassword = document.querySelector('#passwordIcon');

        toggleLoginPassword.addEventListener('click', function (e) {
            const type = loginPassword.getAttribute('type') === 'password' ? 'text' : 'password';
            loginPassword.setAttribute('type', type);
            this.classList.toggle('fa-eye-slash');
        })

        const urlParams = new URLSearchParams( window.location.search );
        jQuery("[name='redirect']").val( urlParams.get('r') );
    }
});